(() => {
  const initialise = (root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const readJSON = (selector, fallback) => { try { return JSON.parse(root.querySelector(selector).textContent); } catch { return fallback; } };
    const products = readJSON('[data-products]', []).filter(p => p.variants && p.variants.length);
    const messages = readJSON('[data-messages]', {});
    const sizeHints = readJSON('[data-size-hints]', {});
    const stylesEl = root.querySelector('[data-styles]');
    const coloursEl = root.querySelector('[data-colours]');
    const sizesEl = root.querySelector('[data-sizes]');
    const add = root.querySelector('[data-add]');
    const checkout = root.querySelector('[data-checkout]');
    const orLabel = root.querySelector('[data-or]');
    const styleStep = root.querySelector('[data-style-step]');
    const reviewsLink = root.querySelector('[data-reviews-link]');
    const backToShop = root.querySelector('[data-back-to-shop]');
    const error = root.querySelector('[data-error]');
    const success = root.querySelector('[data-success]');
    const image = root.querySelector('[data-featured-image]');
    const defaultImage = root.querySelector('[data-default-image]');
    const overlayImage = root.querySelector('[data-featured-overlay]');
    const price = root.querySelector('[data-price]');
    const offerStatus = root.querySelector('[data-offer-status]');
    const offerStatusHeading = root.querySelector('[data-offer-status-heading]');
    const offerStatusCopy = root.querySelector('[data-offer-status-copy]');
    const rootUrl = (root.dataset.root || '/').replace(/\/?$/, '/');
    const iso = root.dataset.currency || 'AUD';
    const formatMoney = (cents) => { try { return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency', currency:iso}).format(cents / 100); } catch { return `${(cents / 100).toFixed(2)} ${iso}`; } };
    const coloursOf = (p) => {
      const i = p.optionNames.findIndex(n => /colou?r/i.test(n));
      return i < 0 ? -1 : i;
    };
    const sizeOf = (p) => p.optionNames.findIndex(n => /size/i.test(n));
    const colourName = (p, v) => { const i = coloursOf(p); return i < 0 ? p.title : v.options[i]; };
    const colourKey = (p, v) => `${p.id}:${colourName(p,v)}`;
    let activeStyle = null, activeColour = null, activeVariantId = null, cart = null, busy = false, justAdded = false, primeCountInCart = 0;
    let galleryRequest = 0;
    let displayedColourKey = null;
    // Liquid price data is only an initial fallback. Fetch the variant prices
    // in the shopper's current presentment currency using Shopify's Ajax Product API.
    // Do not display the unverified initial price while the request is pending.
    for (const product of products) product._localizedPriceStatus = 'pending';
    const button = (className, label, active, click) => {
      const b = document.createElement('button');b.type='button';b.className=className;b.textContent=label;b.setAttribute('aria-pressed',String(active));b.addEventListener('click',click);return b;
    };

    const scrollToStyle = () => {
      if (!styleStep) return;
      const header = document.querySelector('header, .shopify-section-header-sticky, .section-header, #shopify-section-header') || document.querySelector('[data-header]');
      const offset = (header ? header.getBoundingClientRect().height : 0) + 20;
      const top = window.scrollY + styleStep.getBoundingClientRect().top - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    };
    // Separate fixed CTA for customers browsing creator/reviews sections below.
    // It only navigates the page; it never calls Add to Cart or alters variants.
    if (backToShop) {
      let scrollFramePending = false;
      const updateFloatingButton = () => {
        if (!root.isConnected) {
          backToShop.hidden = true;
          return;
        }
        // Stay hidden until the Prime Builder is almost entirely above the viewport.
        // The trigger is based on the end of THIS section, not window scroll distance.
        const threshold = Math.min(160, Math.max(90, window.innerHeight * 0.18));
        backToShop.hidden = root.getBoundingClientRect().bottom > threshold;
      };
      const onViewportChange = () => {
        if (scrollFramePending) return;
        scrollFramePending = true;
        requestAnimationFrame(() => {
          scrollFramePending = false;
          updateFloatingButton();
        });
      };
      backToShop.addEventListener('click', () => {
        const header = document.querySelector('.shopify-section-header-sticky, #shopify-section-header, .section-header');
        const headerOffset = header ? Math.max(0, header.getBoundingClientRect().height) : 0;
        const target = window.scrollY + root.getBoundingClientRect().top - headerOffset - 8;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: Math.max(0, target), behavior: reducedMotion ? 'instant' : 'smooth' });
      });
      window.addEventListener('scroll', onViewportChange, { passive: true });
      window.addEventListener('resize', onViewportChange);
      // Shopify's Theme Editor can replace this section without reloading the page.
      const onSectionUnload = (event) => {
        if (!event.target?.contains(root)) return;
        window.removeEventListener('scroll', onViewportChange);
        window.removeEventListener('resize', onViewportChange);
        document.removeEventListener('shopify:section:unload', onSectionUnload);
      };
      document.addEventListener('shopify:section:unload', onSectionUnload);
      updateFloatingButton();
    }
    const syncSecondaryActions = () => {
      const hasCartItems = !!(cart && cart.item_count > 0);
      if (checkout) checkout.hidden = !hasCartItems;
      if (orLabel) orLabel.hidden = !hasCartItems;
      if (checkout) checkout.disabled = busy || !hasCartItems;
    };
    const productByStyle = () => products.filter(p => p.style === activeStyle);
    const coloursForStyle = () => {
      const result = [];
      for (const p of productByStyle()) for (const v of p.variants) {
        const key = colourKey(p, v);
        if (result.some(x => x.key === key)) continue;
        const matching = p.variants.filter(x => colourKey(p, x) === key);
        // Prefer the matching colour's available variant photo, never the
        // image from a different colour/size when the shopper picks a size.
        const mediaVariant = matching.find(x => x.available && x.image) || matching.find(x => x.image);
        const thumbVariant = matching.find(x => x.available && x.thumb) || matching.find(x => x.thumb);
        result.push({key, product:p, name:colourName(p,v), image:mediaVariant?.image || p.image,
          thumb:thumbVariant?.thumb || p.thumb, available:matching.some(x=>x.available)});
      }
      return result;
    };
    const currentColour = () => coloursForStyle().find(c=>c.key===activeColour);
    const currentVariants = () => {
      const c=currentColour();if (!c)return [];
      return c.product.variants.filter(v=>colourKey(c.product,v)===activeColour);
    };
    const renderStyles = () => {
      stylesEl.replaceChildren();
      for(const style of ['Brief','Jock','Trunk'].filter(s=>products.some(p=>p.style===s))) {
        stylesEl.appendChild(button('prime-builder__style',style,activeStyle===style,()=>{ activeStyle=style;activeColour=null;activeVariantId=null;justAdded=false;success.hidden=true;render(); }));
      }
    };
    const renderColours = () => {
      coloursEl.replaceChildren();const colours=coloursForStyle();
      for(const c of colours) {
        const b=document.createElement('button');b.type='button';b.className='prime-builder__colour';b.dataset.active=String(c.key===activeColour);b.setAttribute('aria-pressed',String(c.key===activeColour));b.disabled=!c.available;
        if(c.thumb||c.image){const im=document.createElement('img');im.src=c.thumb||c.image;im.alt=c.product.title+' — '+c.name;im.loading='lazy';im.decoding='async';im.width=112;im.height=150;b.appendChild(im);}
        const label=document.createElement('span');label.textContent=c.name;b.appendChild(label);
        b.addEventListener('click',()=>{activeColour=c.key;activeVariantId=null;justAdded=false;success.hidden=true;render();});coloursEl.appendChild(b);
      }
      if (!colours.length) coloursEl.textContent='No colours configured.';
    };
    const normaliseSize = (label) => {
      const raw = String(label || '').trim().toUpperCase().replace(/[\s_-]/g, '');
      return ({ 'EXTRASMALL':'XS', 'SMALL':'S', 'MEDIUM':'M', 'LARGE':'L',
        'EXTRALARGE':'XL', 'XLARGE':'XL', '2XL':'XXL', '2X':'XXL',
        'XXLARGE':'XXL', '3XL':'XXXL', '3X':'XXXL', 'XXXLARGE':'XXXL' })[raw] || raw;
    };
    const renderSizes = () => {
      sizesEl.replaceChildren();
      const colour = currentColour();
      if (!colour) return;
      const variants = currentVariants();
      const sizeIndex = sizeOf(colour.product);
      for (const v of variants) {
        const size = sizeIndex < 0 ? v.title : v.options[sizeIndex];
        const hint = sizeHints[normaliseSize(size)] || '';
        const b = button('prime-builder__size', size, activeVariantId === v.id, () => {
          activeVariantId = v.id;
          justAdded = false;
          success.hidden = true;
          renderSizes();
          renderBuy();
        });
        const name = document.createElement('span');
        name.className = 'prime-builder__size-name';
        name.textContent = size;
        b.replaceChildren(name);
        if (hint) {
          const range = document.createElement('span');
          range.className = 'prime-builder__size-hint';
          range.textContent = hint;
          b.appendChild(range);
          b.setAttribute('aria-label', `${size}, ${hint} waist`);
        }
        b.disabled = !v.available;
        sizesEl.appendChild(b);
      }
    };
    const chosen = () => currentVariants().find(v=>v.id===activeVariantId&&v.available);
    const updateGallery = () => {
      const c = currentColour();
      // Always return to the editable campaign image until a COLOUR is chosen;
      // this also runs after Add to cart resets the selection.
      if (!c || !(c.image || c.product.image)) {
        ++galleryRequest;
        displayedColourKey = null;
        if (defaultImage) defaultImage.hidden = false;
        image.hidden = true;
        if (overlayImage) overlayImage.hidden = true;
        return;
      }
      // Size changes must never swap the gallery photo or trigger a reflow.
      if (displayedColourKey === c.key) return;
      const request = ++galleryRequest;
      const url = c.image || c.product.image;
      const alt = `${c.product.title} — ${c.name}`;
      const preload = new Image();
      preload.onload = () => {
        if (request !== galleryRequest) return; // user selected another colour
        image.src = url;
        image.alt = alt;
        image.hidden = false;
        if (defaultImage) defaultImage.hidden = true;
        if (overlayImage) overlayImage.hidden = false;
        displayedColourKey = c.key;
      };
      preload.onerror = () => {
        if (request !== galleryRequest) return;
        displayedColourKey = null;
        image.hidden = true;
        if (overlayImage) overlayImage.hidden = true;
        if (defaultImage) defaultImage.hidden = false;
      };
      preload.src = url;
    };
    const renderBuy = () => {
      const v = chosen();
      const colour = currentColour();
      // A product may have market-specific prices that vary by colour.
      // Before a colour is chosen, show the lowest available price for the
      // selected style (with "From" if prices differ), NOT the first variant.
      // After choosing a colour, use only that colour's variants; after
      // choosing a size, use precisely the selected variant's price.
      const priceProducts = colour ? [colour.product] : productByStyle();
      const pricePending = priceProducts.some(p => p._localizedPriceStatus === 'pending');
      const candidates = v ? [v] : colour
        ? currentVariants().filter(x => x.available)
        : priceProducts.flatMap(p => p.variants.filter(x => x.available));
      const validPrices = candidates.map(x => Number(x.price)).filter(n => Number.isSafeInteger(n) && n >= 0);
      if (pricePending || !validPrices.length) {
        price.textContent = '';
      } else {
        const lowest = Math.min(...validPrices);
        const varies = validPrices.some(n => n !== lowest);
        price.textContent = `${varies ? 'From ' : ''}${formatMoney(lowest)}`;
      }
      add.disabled = busy;
      if (busy) {
        add.textContent = messages.loading || 'ADDING…';
      } else if (v) {
        add.textContent = messages.add || 'ADD TO CART';
      } else if (justAdded) {
        add.textContent = primeCountInCart === 2 ? (messages.next_two || 'ADD ONE MORE FOR 25% OFF') : (messages.next_one || 'WANT MORE? SELECT YOUR NEXT STYLE');
      } else {
        add.textContent = messages.choose || 'CHOOSE YOUR STYLE';
      }
      syncSecondaryActions();
      updateGallery();
    };
    const render = () => {
      if(!activeStyle||!products.some(p=>p.style===activeStyle))activeStyle=products[0]?.style||'Brief';
      const colours=coloursForStyle();if(!colours.some(c=>c.key===activeColour))activeColour=null;
      renderStyles();renderColours();renderSizes();renderBuy();
    };
    const updateOfferMessage = () => {
      // Only merchandise the upgrade at two Prime pairs; don't discourage
      // a customer who is happy checking out with a single pair.
      const primeIds = new Set(products.map(p => String(p.id)));
      const primeCount = (cart?.items || []).reduce((sum, item) =>
        sum + (primeIds.has(String(item.product_id)) ? Number(item.quantity || 0) : 0), 0);
      primeCountInCart = primeCount;
      const totalCount = Number(cart?.item_count || 0);

      if (primeCount < 2) {
        offerStatus.hidden = true;
        offerStatus.removeAttribute('data-state');
        return;
      }

      offerStatus.hidden = false;
      if (primeCount === 2) {
        // Three items of any eligible product already qualify for free
        // standard shipping under the existing storewide offer.
        const shippingUnlocked = totalCount >= 3;
        offerStatus.dataset.state = 'one-more';
        offerStatusHeading.textContent = shippingUnlocked
          ? (messages.two_shipping_heading || 'ONE MORE PAIR = 25% OFF')
          : (messages.two_heading || 'ONE MORE PAIR = 25% OFF + FREE SHIPPING');
        offerStatusCopy.textContent = shippingUnlocked
          ? (messages.two_shipping_copy || 'Free standard shipping is already unlocked. Add 1 more Prime pair to save 25%.')
          : (messages.two_copy || 'Add any Prime brief, jock or trunk in any colour or size.');
      } else {
        offerStatus.dataset.state = 'unlocked';
        offerStatusHeading.textContent = messages.unlocked_heading || '25% OFF + FREE SHIPPING UNLOCKED';
        offerStatusCopy.textContent = messages.unlocked_copy || "You've selected 3 Prime pairs. You're ready to checkout.";
      }
    };
    const loadLocalizedPrices = async () => {
      await Promise.all(products.map(async product => {
        try {
          const response = await fetch(rootUrl + 'products/' + encodeURIComponent(product.handle) + '.js', {
            credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store'
          });
          if (!response.ok) throw new Error(`Product price request failed (${response.status})`);
          const data = await response.json();
          const pricesById = new Map((data.variants || []).map(v => [String(v.id), Number(v.price)]));
          let pricesUpdated = 0;
          for (const variant of product.variants) {
            const amount = pricesById.get(String(variant.id));
            if (Number.isSafeInteger(amount) && amount >= 0) {
              variant.price = amount;
              pricesUpdated += 1;
            }
          }
          if (!pricesUpdated) throw new Error('No matching variant prices in product response');
          product._localizedPriceStatus = 'ready';
        } catch (err) {
          // Fallback only on network/API failure. Do not modify variants or cart.
          product._localizedPriceStatus = 'fallback';
          console.warn('Prime Builder: could not refresh localized product price', product.handle, err);
        }
        if (root.isConnected) renderBuy();
      }));
    };
    const loadCart = async () => {
      const response=await fetch(rootUrl+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'},cache:'no-store'});
      if(!response.ok)throw new Error('Unable to load your cart');cart=await response.json();updateOfferMessage();syncSecondaryActions();
    };
    // Update the existing cart drawer and header without opening the drawer.
    // The theme's standard product form normally calls renderContents(), which
    // opens the drawer; doing that here interrupts building the three-pair offer.
    const cartUI = (payload) => {
      const sections = payload.sections || {};
      const parser = new DOMParser();
      if (sections['cart-icon-bubble']) {
        const current = document.querySelector('#cart-icon-bubble');
        const incoming = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('#cart-icon-bubble');
        if (current && incoming) current.innerHTML = incoming.innerHTML;
      }
      if (sections['cart-drawer']) {
        const drawer = document.querySelector('cart-drawer');
        const currentContent = drawer?.querySelector('#CartDrawer');
        const incomingContent = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
        if (drawer && currentContent && incomingContent) {
          currentContent.innerHTML = incomingContent.innerHTML;
          drawer.classList.toggle('is-empty', !(cart?.item_count > 0));
          // Drawer markup is replaced: restore the overlay close listener.
          drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
        }
      }
    };
    const addToCart = async () => {
      const variant=chosen(), colour=currentColour();if(!variant||busy||!colour)return;
      busy=true;checkout.disabled=true;error.hidden=true;success.hidden=true;renderBuy();
      try {
        const data={items:[{id:variant.id,quantity:1}],sections:['cart-drawer','cart-icon-bubble'],sections_url:window.location.pathname};
        const response=await fetch(rootUrl+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(data)});
        const payload=await response.json();if(!response.ok)throw new Error(payload.description||payload.message||'Could not add to cart');
        // Refresh cart state before showing any progress or success message.
        await loadCart();
        cartUI(payload);
        const selectedSize=sizeOf(colour.product)<0?variant.title:variant.options[sizeOf(colour.product)];
        const name=`${colour.product.title} · ${colour.name} · ${selectedSize}`;
        const strong=document.createElement('strong');strong.textContent=messages.added||'Added to your bag!';
        const detail=document.createElement('div');detail.textContent=name;
        success.replaceChildren(strong,detail);success.hidden=false;
        // Keep style to make repeating easy, reset colour + size to require an explicit new selection.
        activeColour=null;activeVariantId=null;justAdded=true;
        render();
        // render() must not clear the success element.
        success.hidden=false;
        success.scrollIntoView({behavior:'smooth',block:'nearest'});
      } catch(e) {error.textContent=e.message||'Could not add to cart. Please retry.';error.hidden=false;}
      finally {busy=false;checkout.disabled=!(cart && cart.item_count>0);renderBuy();}
    };
    add.addEventListener('click',()=>{ if (chosen()) { addToCart(); } else { scrollToStyle(); } });
    checkout.addEventListener('click',()=>{if(busy||!cart?.item_count)return;window.location.assign(rootUrl+'checkout');});
    reviewsLink?.addEventListener('click', () => {
      const reviewsSection = document.querySelector('[data-djx-prime-reviews], .djx-prime-reviews-section, #PrimeReviews');
      if (!reviewsSection) return;
      const header = document.querySelector('header, .shopify-section-header-sticky, .section-header, #shopify-section-header') || document.querySelector('[data-header]');
      const offset = (header ? header.getBoundingClientRect().height : 0) + 20;
      const top = window.scrollY + reviewsSection.getBoundingClientRect().top - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    });
    document.addEventListener('visibilitychange',()=>{if(!document.hidden)loadCart().catch(()=>{});});
    window.addEventListener('pageshow',()=>loadCart().catch(()=>{}));
    if(!products.length){stylesEl.textContent='Add Prime products to this section in the theme editor.';add.disabled=true;return;}
    activeStyle=products.some(p => p.style === 'Brief') ? 'Brief' : products[0].style;render();
    loadLocalizedPrices().catch(() => {});
    loadCart().catch(()=>{offerStatus.hidden=true;syncSecondaryActions();});
  };
  const boot=()=>document.querySelectorAll('[id^="PrimeBuilder-"]').forEach(initialise);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();